import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-cifris23',
  templateUrl: './home-cifris23.component.html',
  styleUrls: ['./home-cifris23.component.css']
})
export class HomeCifris23Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
